/* eslint-disable consistent-this */
import React, { PureComponent } from 'react';
import styles from './index.css';
import Slides from '@ifeng-fe/ui_pc_slides';
import { formatImage } from '@ifeng-fe/container_channel/common/client/winter/utils/formatImg';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
import Video from '../../../components/video';
import { Player } from 'ThreeTerminal_pc/video';
import { getVideoDetail, getVideoList } from '../../../../services/api';

const VideoBox = errorBoundary(
    class extends PureComponent {
        state = {
            videoIndex: 0,
            videoPlay: this.props.play,
            vConfig: {},
            list: [],
        };
        static propTypes = {
            content: PropTypes.array,
            play: PropTypes.bool,
        };
        UNSAFE_componentWillReceiveProps(nextProps) {
            // console.log('nextProps==', nextProps);
            if (nextProps.play !== this.state.videoPlay) {
                this.setState({
                    videoPlay: nextProps.play,
                });
            }
        }
        async componentDidMount() {
            const index = this.state.videoIndex;
            const videos = this.props.content;
            const idString = this.videoArr(videos);

            const videoList = await getVideoList(idString);
            const guid = videos[index].guid;

            if (videoList.code === 0) {
                const newList = videoList.data;
                const first = newList.filter(item => item.guid === guid);

                this.setState({
                    list: newList,
                    vConfig: first[0],
                });
            } else {
                // 获取失败
            }
        }
        videoArr = ids => {
            let guids = '';

            // eslint-disable-next-line array-callback-return
            ids.map(item => {
                // guids.push(item.guid);
                guids += `${item.guid},`;
            });

            return guids;
        };
        changeVideo = index => {
            this.setState({
                videoPlay: false,
            });
            this.setState(
                {
                    videoIndex: index,
                },
                () => {
                    // this.setState({ videoPlay: true });
                    this.getNextVideo(index);
                },
            );
        };
        getNextVideo = async index => {
            const guid = this.props.content[index].guid;
            const newList = this.state.list;
            const video = newList.filter(item => item.guid === guid);

            this.setState({
                vConfig: video[0],
                videoPlay: true,
            });
        };

        render() {
            const { content, play } = this.props;
            const { videoIndex, videoPlay, vConfig } = this.state;
            const newList = content.map((item, index) => ({
                num: index,
                guid: item.guid,
                title: item.title,
            }));
            const videoSlide = [newList.slice(0, 3), newList.slice(3)];

            // console.log('vConfig===', vConfig);

            let _this = this;

            const sliderTmpl = function sliderTmpl(newContent) {
                const videoNum = _this.state.videoIndex;

                return newContent.map(
                    // eslint-disable-next-line no-confusing-arrow
                    (item, index) =>
                        item.num === videoNum ? (
                            <li
                                name={item.guid}
                                key={index}
                                className={styles.current}
                                onClick={_this.changeVideo.bind(_this, item.num)}>
                                <a href="javascript:void(0);">
                                    <div>{item.title}</div>
                                </a>
                            </li>
                        ) : (
                            <li name={item.guid} key={index} onClick={_this.changeVideo.bind(_this, item.num)}>
                                <a href="javascript:void(0);">
                                    <div>{item.title}</div>
                                </a>
                            </li>
                        ),
                );
            };

            const config = {
                arrows: true,
                dots: false,
                // dotsAction: 'click',
                autoplay: false,
                unitSize: 864,
                extension: 2,
                dotCurrentStyle: styles.current,
                sliderTmpl,
            };
            const playermsg = {
                width: 778,
                height: 450,
                autoPlay: play,
                controls: true,
            };

            console.log('playermsg==', playermsg);

            return (
                <div>
                    <div className={styles.vedio}>
                        {videoPlay ? <Player videoConfig={vConfig} playermsg={playermsg} /> : ''}
                    </div>
                    <div className={styles.vedios_li}>
                        <div className={styles.vedio_container}>
                            <ul className={styles.playitem}>
                                <Slides config={config} content={videoSlide} />
                            </ul>
                        </div>
                    </div>
                </div>
            );
        }
    },
);

export { VideoBox };
export default VideoBox;
